<template>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
export default {
  created() {
    modifyNetTitle('组织架构')
  },
};
</script>
<style lang="scss" scoped></style>
